"use client";

import {vars} from "nativewind";

const light = {
    "--color-primary-0": "rgb(239 246 255)", // #eff6ff
    "--color-primary-50": "rgb(239 246 255)", // #eff6ff
    "--color-primary-100": "rgb(219 234 254)", // #dbeafe
    "--color-primary-200": "rgb(191 219 254)", // #bfdbfe
    "--color-primary-300": "rgb(147 197 253)", // #93c5fd
    "--color-primary-400": "rgb(96 165 250)", // #60a5fa
    "--color-primary-500": "rgb(59 130 246)", // #3b82f6
    "--color-primary-600": "rgb(37 99 235)", // #2563eb
    "--color-primary-700": "rgb(29 78 216)", // #1d4ed8
    "--color-primary-800": "rgb(30 64 175)", // #1e40af
    "--color-primary-900": "rgb(30 58 138)", // #1e3a8a
    "--color-primary-950": "rgb(8 8 8)",

    /* Secondary  */
    "--color-secondary-0": "rgb(254 255 255)",
    "--color-secondary-50": "rgb(241 242 242)",
    "--color-secondary-100": "rgb(231 232 232)",
    "--color-secondary-200": "rgb(219 219 219)",
    "--color-secondary-300": "rgb(175 176 176)",
    "--color-secondary-400": "rgb(114 115 115)",
    "--color-secondary-500": "rgb(94 95 95)",
    "--color-secondary-600": "rgb(81 82 82)",
    "--color-secondary-700": "rgb(63 64 64)",
    "--color-secondary-800": "rgb(39 38 38)",
    "--color-secondary-900": "rgb(24 23 23)",
    "--color-secondary-950": "rgb(11 12 12)",

    /* Tertiary */
    "--color-tertiary-0": "rgb(255 250 245)",
    "--color-tertiary-50": "rgb(255 242 229)",
    "--color-tertiary-100": "rgb(255 233 213)",
    "--color-tertiary-200": "rgb(254 209 170)",
    "--color-tertiary-300": "rgb(253 180 116)",
    "--color-tertiary-400": "rgb(251 157 75)",
    "--color-tertiary-500": "rgb(231 129 40)",
    "--color-tertiary-600": "rgb(215 117 31)",
    "--color-tertiary-700": "rgb(180 98 26)",
    "--color-tertiary-800": "rgb(130 73 23)",
    "--color-tertiary-900": "rgb(108 61 19)",
    "--color-tertiary-950": "rgb(84 49 18)",

    /* Error */
    "--color-error-0": "rgb(254 233 233)", // #FEE9E9
    "--color-error-50": "rgb(254 226 226)", // #FEE2E2
    "--color-error-100": "rgb(254 202 202)", // #FECACA
    "--color-error-200": "rgb(252 165 165)", // #FCA5A5
    "--color-error-300": "rgb(248 113 113)", // #F87171
    "--color-error-400": "rgb(239 68 68)", // #EF4444
    "--color-error-500": "rgb(230 53 53)", // #E63535
    "--color-error-600": "rgb(220 38 38)", // #DC2626
    "--color-error-700": "rgb(185 28 28)", // #B91C1C
    "--color-error-800": "rgb(153 27 27)", // #991B1B
    "--color-error-900": "rgb(127 29 29)", // #7F1D1D
    "--color-error-950": "rgb(83 19 19)", // #531313

    /* Success */
    "--color-success-0": "rgb(228 255 244)",
    "--color-success-50": "rgb(240 253 244)", // #f0fdf4
    "--color-success-100": "rgb(220 252 231)", // #dcfce7
    "--color-success-200": "rgb(187 247 208)", // #bbf7d0
    "--color-success-300": "rgb(134 239 172)", // #86efac
    "--color-success-400": "rgb(74 222 128)", // #4ade80
    "--color-success-500": "rgb(34 197 94)", // #22c55e
    "--color-success-600": "rgb(22 163 74)", // #16a34a
    "--color-success-700": "rgb(21 128 61)", // #15803d
    "--color-success-800": "rgb(22 101 52)", // #166534
    "--color-success-900": "rgb(20 83 45)", // #14532d
    "--color-success-950": "rgb(27 50 36)",

    /* Info */
    "--color-info-0": "rgb(236 248 254)",
    "--color-info-50": "rgb(199 235 252)",
    "--color-info-100": "rgb(162 221 250)",
    "--color-info-200": "rgb(124 207 248)",
    "--color-info-300": "rgb(87 194 246)",
    "--color-info-400": "rgb(50 180 244)",
    "--color-info-500": "rgb(13 166 242)",
    "--color-info-600": "rgb(11 141 205)",
    "--color-info-700": "rgb(9 115 168)",
    "--color-info-800": "rgb(7 90 131)",
    "--color-info-900": "rgb(5 64 93)",
    "--color-info-950": "rgb(3 38 56)",

    /* Typography */
    "--color-typography-0": "rgb(254 254 255)",
    "--color-typography-50": "rgb(245 245 245)",
    "--color-typography-100": "rgb(229 229 229)",
    "--color-typography-200": "rgb(219 219 220)",
    "--color-typography-300": "rgb(212 212 212)",
    "--color-typography-400": "rgb(163 163 163)",
    "--color-typography-500": "rgb(140 140 140)",
    "--color-typography-600": "rgb(115 115 115)",
    "--color-typography-700": "rgb(82 82 82)",
    "--color-typography-800": "rgb(64 64 64)",
    "--color-typography-900": "rgb(38 38 39)",
    "--color-typography-950": "rgb(23 23 23)",

    /* Outline */
    "--color-outline-0": "rgb(253 254 254)",
    "--color-outline-50": "rgb(243 243 243)",
    "--color-outline-100": "rgb(230 230 230)",
    "--color-outline-200": "rgb(221 220 219)",
    "--color-outline-300": "rgb(211 211 211)",
    "--color-outline-400": "rgb(165 163 163)",
    "--color-outline-500": "rgb(140 141 141)",
    "--color-outline-600": "rgb(115 116 116)",
    "--color-outline-700": "rgb(83 82 82)",
    "--color-outline-800": "rgb(65 65 65)",
    "--color-outline-900": "rgb(39 38 36)",
    "--color-outline-950": "rgb(26 23 23)",

    /* Background */
    "--color-background-0": "rgb(255 255 255)",
    "--color-background-50": "rgb(246 246 246)",
    "--color-background-100": "rgb(242 241 241)",
    "--color-background-200": "rgb(220 219 219)",
    "--color-background-300": "rgb(213 212 212)",
    "--color-background-400": "rgb(162 163 163)",
    "--color-background-500": "rgb(142 142 142)",
    "--color-background-600": "rgb(116 116 116)",
    "--color-background-700": "rgb(83 82 82)",
    "--color-background-800": "rgb(65 64 64)",
    "--color-background-900": "rgb(39 38 37)",
    "--color-background-950": "rgb(24 23 24)",

    /* Background Special */
    "--color-background-error": "rgb(254 241 241)",
    "--color-background-warning": "rgb(255 244 235)",
    "--color-background-success": "rgb(237 252 242)",
    "--color-background-muted": "rgb(247 248 247)",
    "--color-background-info": "rgb(235 248 254)",

    /* Focus Ring Indicator  */
    "--color-indicator-primary": "rgb(55 55 55)",
    "--color-indicator-info": "rgb(83 153 236)",
    "--color-indicator-error": "rgb(185 28 28)",

    /* blueGray */
    "--color-blueGray-50": "rgb(249 250 251)",
    "--color-blueGray-100": "rgb(243 244 246)",
    "--color-blueGray-200": "rgb(229 231 235)",
    "--color-blueGray-300": "rgb(209 213 219)",
    "--color-blueGray-400": "rgb(160 174 189)",
    "--color-blueGray-500": "rgb(113 118 123)",
    "--color-blueGray-600": "rgb(81 85 92)",
    "--color-blueGray-700": "rgb(63 67 76)",
    "--color-blueGray-800": "rgb(47 54 64)",
    "--color-blueGray-900": "rgb(39 42 51)",
    "--color-blueGray-950": "rgb(23 25 30)",

    /* blue */
    "--color-blue-50": "rgb(239 246 255)", // "#eff6ff",
    "--color-blue-100": "rgb(219 234 254)", // "#dbeafe",
    "--color-blue-200": "rgb(191 219 254)", // "#bfdbfe",
    "--color-blue-300": "rgb(147 197 253)", // "#93c5fd",
    "--color-blue-400": "rgb(96 165 250)", // "#60a5fa",
    "--color-blue-500": "rgb(59 130 246)", // "#3b82f6",
    "--color-blue-600": "rgb(37 99 235)", // "#2563eb",
    "--color-blue-700": "rgb(29 78 216)", // "#1d4ed8",
    "--color-blue-800": "rgb(30 64 175)", // "#1e40af",
    "--color-blue-900": "rgb(30 58 138)", // "#1e3a8a"

    /* Airbnb */
    "--color-Airbnb-background": "rgb(255 223 229)", // #FFDFE5
    "--color-Airbnb-border": "rgb(255 56 92)", // #FF385C
    "--color-Airbnb-text": "rgb(255 56 92)", // #FF385C
    "--color-Airbnb-avatar": "rgb(255 56 92)", // #FF385C

    /* Booking */
    "--color-Booking-background": "rgb(239 241 254)", // #EFF1FE
    "--color-Booking-border": "rgb(0 59 149)", // #003B95
    "--color-Booking-text": "rgb(0 59 149)", // #003B95
    "--color-Booking-avatar": "rgb(0 59 149)", // #003B95

    /* Houfy */
    "--color-Houfy-background": "rgb(246 233 255)", // #F6E9FF
    "--color-Houfy-border": "rgb(173 104 221)", // #AD68DD
    "--color-Houfy-text": "rgb(173 104 221)", // #AD68DD
    "--color-Houfy-avatar": "rgb(21 61 89)", // #153D59

    /* HomeAway */
    "--color-HomeAway-background": "rgb(242 242 242)", // #F2F2F2
    "--color-HomeAway-border": "rgb(0 0 0)", // #000000
    "--color-HomeAway-text": "rgb(0 0 0)", // #000000
    "--color-HomeAway-avatar": "rgb(36 90 188)", // #245ABC

    /* Internal */
    "--color-internal-background": "rgb(240 253 244)", // #F0FDF4
    "--color-internal-border": "rgb(54 189 182)", // #36BDB6
    "--color-internal-text": "rgb(54 189 182)", // #36BDB6
    "--color-internal-avatar": "rgb(54 189 182)", // #36BDB6

    /* iCalendar */
    "--color-icalendar-background": "rgb(255 246 224)", // #FFF6E0
    "--color-icalendar-border": "rgb(255 192 77)", // #FFC04D
    "--color-icalendar-text": "rgb(245 158 11)", // #F59E0B
    "--color-icalendar-avatar": "rgb(234 88 12)", // #EA580C

    /* Direct */
    "--color-direct-background": "rgb(224 255 253)", // #E0FFFD
    "--color-direct-border": "rgb(54 189 182)", // #36BDB6
    "--color-direct-text": "rgb(54 189 182)", // #36BDB6
    "--color-direct-avatar": "rgb(54 189 182)", // #36BDB6

    /* ChannelConnector */
    "--color-ChannelConnector-background": "rgb(30 41 59)", // #1E293B
    "--color-ChannelConnector-border": "rgb(191 219 254)", // #BFDBFE
    "--color-ChannelConnector-text": "rgb(147 197 253)", // #93C5FD
    "--color-ChannelConnector-avatar": "rgb(96 165 250)" // #60A5FA
} as const;

const dark = {
    "--color-primary-0": "rgb(239 246 255)", // #eff6ff
    "--color-primary-50": "rgb(239 246 255)", // #eff6ff
    "--color-primary-100": "rgb(219 234 254)", // #dbeafe
    "--color-primary-200": "rgb(191 219 254)", // #bfdbfe
    "--color-primary-300": "rgb(147 197 253)", // #93c5fd
    "--color-primary-400": "rgb(96 165 250)", // #60a5fa
    "--color-primary-500": "rgb(59 130 246)", // #3b82f6
    "--color-primary-600": "rgb(37 99 235)", // #2563eb
    "--color-primary-700": "rgb(29 78 216)", // #1d4ed8
    "--color-primary-800": "rgb(30 64 175)", // #1e40af
    "--color-primary-900": "rgb(30 58 138)", // #1e3a8a
    "--color-primary-950": "rgb(8 8 8)",

    /* Secondary  */
    "--color-secondary-0": "rgb(11 12 12)",
    "--color-secondary-50": "rgb(24 23 23)",
    "--color-secondary-100": "rgb(39 38 38)",
    "--color-secondary-200": "rgb(63 64 64)",
    "--color-secondary-300": "rgb(81 82 82)",
    "--color-secondary-400": "rgb(94 95 95)",
    "--color-secondary-500": "rgb(114 115 115)",
    "--color-secondary-600": "rgb(175 176 176)",
    "--color-secondary-700": "rgb(219 219 219)",
    "--color-secondary-800": "rgb(231 232 232)",
    "--color-secondary-900": "rgb(241 242 242)",
    "--color-secondary-950": "rgb(254 255 255)",

    /* Tertiary */
    "--color-tertiary-0": "rgb(84 49 18)",
    "--color-tertiary-50": "rgb(108 61 19)",
    "--color-tertiary-100": "rgb(130 73 23)",
    "--color-tertiary-200": "rgb(180 98 26)",
    "--color-tertiary-300": "rgb(215 117 31)",
    "--color-tertiary-400": "rgb(231 129 40)",
    "--color-tertiary-500": "rgb(251 157 75)",
    "--color-tertiary-600": "rgb(253 180 116)",
    "--color-tertiary-700": "rgb(254 209 170)",
    "--color-tertiary-800": "rgb(255 233 213)",
    "--color-tertiary-900": "rgb(255 242 229)",
    "--color-tertiary-950": "rgb(255 250 245)",

    /* Error */
    "--color-error-0": "rgb(83 19 19)",
    "--color-error-50": "rgb(127 29 29)",
    "--color-error-100": "rgb(153 27 27)",
    "--color-error-200": "rgb(185 28 28)",
    "--color-error-300": "rgb(220 38 38)",
    "--color-error-400": "rgb(230 53 53)",
    "--color-error-500": "rgb(239 68 68)",
    "--color-error-600": "rgb(248 113 113)",
    "--color-error-700": "rgb(252 165 165)",
    "--color-error-800": "rgb(254 202 202)",
    "--color-error-900": "rgb(254 226 226)",
    "--color-error-950": "rgb(254 233 233)",

    /* Success */
    "--color-success-0": "rgb(27 50 36)",
    "--color-success-50": "rgb(20 83 45)",
    "--color-success-100": "rgb(22 101 52)",
    "--color-success-200": "rgb(32 111 62)",
    "--color-success-300": "rgb(42 121 72)",
    "--color-success-400": "rgb(52 131 82)",
    "--color-success-500": "rgb(72 151 102)",
    "--color-success-600": "rgb(102 181 132)",
    "--color-success-700": "rgb(132 211 162)",
    "--color-success-800": "rgb(162 241 192)",
    "--color-success-900": "rgb(202 255 232)",
    "--color-success-950": "rgb(228 255 244)",

    /* Info */
    "--color-info-0": "rgb(3 38 56)",
    "--color-info-50": "rgb(5 64 93)",
    "--color-info-100": "rgb(7 90 131)",
    "--color-info-200": "rgb(9 115 168)",
    "--color-info-300": "rgb(11 141 205)",
    "--color-info-400": "rgb(13 166 242)",
    "--color-info-500": "rgb(50 180 244)",
    "--color-info-600": "rgb(87 194 246)",
    "--color-info-700": "rgb(124 207 248)",
    "--color-info-800": "rgb(162 221 250)",
    "--color-info-900": "rgb(199 235 252)",
    "--color-info-950": "rgb(236 248 254)",

    /* Typography */
    "--color-typography-0": "rgb(23 23 23)",
    "--color-typography-50": "rgb(38 38 39)",
    "--color-typography-100": "rgb(64 64 64)",
    "--color-typography-200": "rgb(82 82 82)",
    "--color-typography-300": "rgb(115 115 115)",
    "--color-typography-400": "rgb(140 140 140)",
    "--color-typography-500": "rgb(163 163 163)",
    "--color-typography-600": "rgb(212 212 212)",
    "--color-typography-700": "rgb(219 219 220)",
    "--color-typography-800": "rgb(229 229 229)",
    "--color-typography-900": "rgb(245 245 245)",
    "--color-typography-950": "rgb(254 254 255)",

    /* Outline */
    "--color-outline-0": "rgb(26 23 23)",
    "--color-outline-50": "rgb(39 38 36)",
    "--color-outline-100": "rgb(65 65 65)",
    "--color-outline-200": "rgb(83 82 82)",
    "--color-outline-300": "rgb(115 116 116)",
    "--color-outline-400": "rgb(140 141 141)",
    "--color-outline-500": "rgb(165 163 163)",
    "--color-outline-600": "rgb(211 211 211)",
    "--color-outline-700": "rgb(221 220 219)",
    "--color-outline-800": "rgb(230 230 230)",
    "--color-outline-900": "rgb(243 243 243)",
    "--color-outline-950": "rgb(253 254 254)",

    /* Background */
    "--color-background-0": "rgb(15 23 42)", // #0F172A
    "--color-background-50": "rgb(39 38 37)",
    "--color-background-100": "rgb(65 64 64)",
    "--color-background-200": "rgb(83 82 82)",
    "--color-background-300": "rgb(116 116 116)",
    "--color-background-400": "rgb(142 142 142)",
    "--color-background-500": "rgb(162 163 163)",
    "--color-background-600": "rgb(213 212 212)",
    "--color-background-700": "rgb(220 219 219)",
    "--color-background-800": "rgb(242 241 241)",
    "--color-background-900": "rgb(246 246 246)",
    "--color-background-950": "rgb(254 254 254)",

    /* Background Special */
    "--color-background-error": "rgb(66 43 43)",
    "--color-background-warning": "rgb(65 47 35)",
    "--color-background-success": "rgb(28 43 33)",
    "--color-background-muted": "rgb(51 51 51)",
    "--color-background-info": "rgb(26 40 46)",

    /* Focus Ring Indicator  */
    "--color-indicator-primary": "rgb(247 247 247)",
    "--color-indicator-info": "rgb(161 199 245)",
    "--color-indicator-error": "rgb(232 70 69)",

    /* blueGray */
    "--color-blueGray-50": "rgb(30 41 59)", // #1E293B collected from reservations details
    "--color-blueGray-100": "rgb(30 41 59)",
    "--color-blueGray-200": "rgb(148 163 184)", // #94A3B8 collected from calendar
    "--color-blueGray-300": "rgb(209 213 219)",
    "--color-blueGray-400": "rgb(160 174 189)",
    "--color-blueGray-500": "rgb(113 118 123)",
    "--color-blueGray-600": "rgb(148 163 184)", // #94A3B8
    "--color-blueGray-700": "rgb(63 67 76)",
    "--color-blueGray-800": "rgb(248 250 252)", // #F8FAFC
    "--color-blueGray-900": "rgb(39 42 51)",
    "--color-blueGray-950": "rgb(23 25 30)",

    /* blue */
    "--color-blue-50": "rgb(30 41 59)", // "#1E293B",
    "--color-blue-100": "rgb(219 234 254)", // "#dbeafe",
    "--color-blue-200": "rgb(191 219 254)", // "#bfdbfe",
    "--color-blue-300": "rgb(147 197 253)", // "#93c5fd",
    "--color-blue-400": "rgb(96 165 250)", // "#60a5fa",
    "--color-blue-500": "rgb(59 130 246)", // "#3b82f6",
    "--color-blue-600": "rgb(37 99 235)", // "#2563eb",
    "--color-blue-700": "rgb(29 78 216)", // "#1d4ed8",
    "--color-blue-800": "rgb(30 64 175)", // "#1e40af",
    "--color-blue-900": "rgb(30 58 138)", // "#1e3a8a",

    /* Airbnb */
    "--color-Airbnb-background": "rgb(255 223 229)", // #FFDFE5
    "--color-Airbnb-border": "rgb(255 56 92)", // #FF385C
    "--color-Airbnb-text": "rgb(255 56 92)", // #FF385C
    "--color-Airbnb-avatar": "rgb(255 56 92)", // #FF385C

    /* Booking */
    "--color-Booking-background": "rgb(239 241 254)", // #EFF1FE
    "--color-Booking-border": "rgb(0 59 149)", // #003B95
    "--color-Booking-text": "rgb(0 59 149)", // #003B95
    "--color-Booking-avatar": "rgb(0 59 149)", // #003B95

    /* Houfy */
    "--color-Houfy-background": "rgb(246 233 255)", // #F6E9FF
    "--color-Houfy-border": "rgb(173 104 221)", // #AD68DD
    "--color-Houfy-text": "rgb(173 104 221)", // #AD68DD
    "--color-Houfy-avatar": "rgb(21 61 89)", // #153D59

    /* HomeAway */
    "--color-HomeAway-background": "rgb(242 242 242)", // #F2F2F2
    "--color-HomeAway-border": "rgb(0 0 0)", // #000000
    "--color-HomeAway-text": "rgb(0 0 0)", // #000000
    "--color-HomeAway-avatar": "rgb(36 90 188)", // #245ABC

    /* Internal */
    "--color-internal-background": "rgb(240 253 244)", // #F0FDF4
    "--color-internal-border": "rgb(54 189 182)", // #36BDB6
    "--color-internal-text": "rgb(54 189 182)", // #36BDB6
    "--color-internal-avatar": "rgb(54 189 182)", // #36BDB6

    /* iCalendar */
    "--color-icalendar-background": "rgb(255 246 224)", // #FFF6E0
    "--color-icalendar-border": "rgb(255 192 77)", // #FFC04D
    "--color-icalendar-text": "rgb(245 158 11)", // #F59E0B
    "--color-icalendar-avatar": "rgb(234 88 12)", // #EA580C

    /* Direct */
    "--color-direct-background": "rgb(224 255 253)", // #E0FFFD
    "--color-direct-border": "rgb(54 189 182)", // #36BDB6
    "--color-direct-text": "rgb(54 189 182)", // #36BDB6
    "--color-direct-avatar": "rgb(54 189 182)", // #36BDB6

    /* ChannelConnector */
    "--color-ChannelConnector-background": "rgb(30 41 59)", // #1E293B
    "--color-ChannelConnector-border": "rgb(191 219 254)", // #BFDBFE
    "--color-ChannelConnector-text": "rgb(147 197 253)", // #93C5FD
    "--color-ChannelConnector-avatar": "rgb(96 165 250)" // #60A5FA
} as const;

export const config = {
    light: vars(light) as typeof light,
    dark: vars(dark) as typeof dark
};
